import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { RotateCcw } from 'lucide-react';
import { ConfirmModal } from '../ui/ConfirmModal';

export function MaintenanceCard({ items, canOperate, busy, onReset }) {
    const { t } = useTranslation();
    const [target, setTarget] = useState(null);
    if (!items?.length) return null;

    const partName = (m) => t(`maison.parts.${m.key}`, { defaultValue: m.name });

    return (
        <section className="mb-6">
            <h3 className="text-sm font-semibold uppercase tracking-wide text-muted-foreground mb-2">{t('maison.maintenance')}</h3>
            <div className="bg-card border border-border rounded-xl divide-y divide-border">
                {items.map(m => {
                    const pct = Math.max(m.pct, 0);
                    return (
                        <div key={m.key} className="px-4 py-3">
                            <div className="flex justify-between items-center text-sm mb-1.5 gap-2">
                                <span>{partName(m)}</span>
                                <span className="flex items-center gap-3">
                                    <span className="tabular-nums text-muted-foreground">{pct} %</span>
                                    {canOperate && (
                                        <button type="button" disabled={busy} onClick={() => setTarget(m)}
                                            title={t('maison.reset')} aria-label={`${t('maison.reset')} ${partName(m)}`}
                                            className="p-1.5 rounded-md border border-border hover:bg-accent disabled:opacity-50">
                                            <RotateCcw className="w-3.5 h-3.5" />
                                        </button>
                                    )}
                                </span>
                            </div>
                            <div className="h-1.5 rounded-full bg-muted overflow-hidden">
                                <div className="h-full rounded-full transition-all"
                                    style={{ width: `${pct}%`, background: pct <= 0 ? '#ef4444' : pct < 20 ? '#f59e0b' : '#22c55e' }} />
                            </div>
                        </div>
                    );
                })}
            </div>
            <ConfirmModal
                isOpen={!!target}
                title={t('maison.resetTitle')}
                message={target ? t('maison.resetMessage', { part: partName(target) }) : ''}
                confirmText={t('maison.confirm')}
                cancelText={t('maison.cancel')}
                onCancel={() => setTarget(null)}
                onConfirm={() => { const k = target.key; setTarget(null); onReset(k); }}
            />
        </section>
    );
}
